import { CheckboxTableRow, ExTable, TableBody, TableHead, useMultipleCheckForm } from 'components/shared/widget'
import { useForm } from 'utils/hooks'
import { Patient, PatientSearchForm } from 'entities/patient'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import { patientColumnInfoList, PatientTableData } from 'components/patient/patient_table'
import { useFetchPatientsApi } from 'api/patient'
import BaseSelectModal from 'components/shared/base_select_modal'

type SelectPatientModalProps = {
    defaultSearchForm?: PatientSearchForm
    openButtonText: string
    executeButtonText: string
    onClick: (patients: Patient[]) => void
    onChange?: (patients: Patient[]) => void
    dropdown?: boolean
    hiddenSearchParams?: string[]
    circle?: boolean
    variant?: string
    onOpen?: () => void
    disableList?: number[]
    show?: boolean
    onHide?: () => void
    maxItemCount?: number
    items?: Patient[]
}

const SelectPatientModal = (props: SelectPatientModalProps) => {
    const searchForm = useForm<PatientSearchForm>(props.defaultSearchForm ? props.defaultSearchForm : {})
    const api = useFetchPatientsApi(searchForm)
    const patientDisplaySetting = useDisplaySetting(patientColumnInfoList(searchForm), 'SelectPatient', 'default_visible', [])
    const multipleCheckForm = useMultipleCheckForm<Patient>()

    const items = () => {
        if (props.items) {
            return props.items
        } else {
            return api.response.results
        }
    }

    return (
        <>
            <BaseSelectModal
                title="Patient選択"
                multipleCheckForm={multipleCheckForm}
                searchForm={searchForm}
                pageSet={api.pageSet}
                pagingResponse={api.response}
                {...props}
                onOpen={() => {
                    if (props.onOpen) {
                        props.onOpen()
                    }
                    multipleCheckForm.form.resetForm()
                    api.execute()
                }}
            >
                <div>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow
                                head
                                allCheck
                                allItems={items()}
                                multipleCheckForm={multipleCheckForm}
                                disableList={props.disableList}
                                maxItemCount={props.maxItemCount}
                            >
                                <TableHeads displaySetting={patientDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading}>
                            {items().map((patient: Patient) => {
                                return (
                                    <CheckboxTableRow
                                        key={`patient-${patient.id}`}
                                        item={patient}
                                        multipleCheckForm={multipleCheckForm}
                                        disableList={props.disableList}
                                        maxItemCount={props.maxItemCount}
                                    >
                                        <PatientTableData patient={patient} displaySetting={patientDisplaySetting} admin />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                </div>
            </BaseSelectModal>
        </>
    )
}

export default SelectPatientModal
